(function () {
  function init(root) {
    var form = root.querySelector('[data-track-order-form]');
    var numberInput = root.querySelector('[data-track-order-number]');
    var emailInput = root.querySelector('[data-track-order-email]');
    var errorEl = root.querySelector('[data-track-order-error]');
    var result = root.querySelector('[data-track-order-result]');
    var summary = root.querySelector('[data-track-order-summary]');

    if (!form || !numberInput || !emailInput || !result || !summary) return;

    function fail(field, message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      field.setAttribute('aria-invalid', 'true');
      field.focus();
      result.hidden = true;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var orderNumber = numberInput.value.trim().replace(/^#\s*/, '');
      var email = emailInput.value.trim();

      numberInput.removeAttribute('aria-invalid');
      emailInput.removeAttribute('aria-invalid');

      if (!orderNumber) {
        fail(numberInput, 'Enter your order number.');
        return;
      }
      if (!email) {
        fail(emailInput, 'Enter the email address you used at checkout.');
        return;
      }
      if (email.indexOf('@') < 1 || email.indexOf('.', email.indexOf('@')) < 0) {
        fail(emailInput, 'That email address looks incomplete.');
        return;
      }

      errorEl.hidden = true;
      errorEl.textContent = '';
      summary.textContent = 'Order #' + orderNumber;
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  function run() {
    document.querySelectorAll('[data-track-order]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
